export type OneTrustSite = {
  enabled: boolean;
  prod: string;
  uat: string;
};

// Keyed by dealership pathname id, or 'carvana' for the main carvana.com site.
// `enabled` is the go-live switch — an entry can exist (e.g. with real GUIDs
// staged ahead of launch) without rendering until it is flipped to true.
const oneTrustScripts: Record<string, OneTrustSite> = {
  'atl-cdjr-new': {
    enabled: true,
    prod: '019e98c6-acd2-7e45-a03c-2dbf3a33ac8a',
    uat: '01a05f2a-5a32-73fd-af1e-6d70043374d8'
  },
  'bos-cdjr-new': {
    enabled: true,
    prod: '019e98c7-0d69-778f-a6f7-96cb1d0d9b0d',
    uat: '01a05f2a-cdd4-7ac6-a527-bfa1a8e8c718'
  },
  carvana: {
    enabled: false,
    prod: '',
    uat: ''
  },
  'casd-cdjr-new': {
    enabled: true,
    prod: '019e98c8-5d42-7ed5-8a05-0884e26dd5a7',
    uat: '01a08808-8d47-729d-8e91-1ed69ed8ab0d'
  },
  'cg-cdjr-new': {
    enabled: true,
    prod: '019e9424-0141-7ae8-922e-ec4992ac00c3',
    uat: '01a05f2b-3cb9-7645-9f56-1547f8283beb'
  },
  'cle-cdjr-new': {
    enabled: true,
    prod: '019e98c8-cc94-7be7-9ef0-6abaf7690825',
    uat: '01a05f2b-ee9c-7c7f-a430-3821b02b9d7e'
  },
  'dal-cdjr-new': {
    enabled: true,
    prod: '019e98c7-6c4f-7444-a35e-68d9804807d8',
    uat: '01a05f2c-4569-7821-aeb2-690f1a594e2c'
  },
  'sac-cdjr-new': {
    enabled: true,
    prod: '019e98c7-f054-708c-9c88-cbf6909b2999',
    uat: '01a02504-ea39-79b5-8f06-f1fd286ca885'
  }
};

export default oneTrustScripts;
